/**
 * ss-collection-facets-ajax.js — Auto-apply filters, sort & pagination for collection/search
 */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function getSectionId() {
    var grid = document.getElementById('product-grid');
    return grid && grid.dataset.id;
  }

  function getUrlParams() {
    return new URLSearchParams(window.location.search);
  }

  /** Build URL from form — supports multi-value filter checkboxes via append */
  function urlFromForm(form, opts) {
    opts = opts || {};
    var targetUrl = new URL(window.location.pathname, window.location.origin);
    if (form) {
      var formParams = new URLSearchParams(new FormData(form));
      formParams.forEach(function (value, key) {
        if (key === 'page') return;
        targetUrl.searchParams.append(key, value);
      });
    }

    if (opts.resetPage) {
      targetUrl.searchParams.delete('page');
    } else if (opts.page) {
      targetUrl.searchParams.set('page', String(opts.page));
    } else {
      var urlPage = getUrlParams().get('page');
      if (urlPage) targetUrl.searchParams.set('page', urlPage);
    }

    return targetUrl;
  }

  function fetchAndRenderUrl(targetUrl, opts) {
    var sectionId = getSectionId();
    if (!sectionId) {
      window.location.href = targetUrl.toString();
      return;
    }

    opts = opts || {};
    var fetchUrl = new URL(targetUrl.toString(), window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    var container = document.getElementById('ProductGridContainer');
    if (container) container.classList.add('is-loading');

    fetch(fetchUrl.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('fetch failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newContainer = doc.getElementById('ProductGridContainer');
        var currentContainer = document.getElementById('ProductGridContainer');
        if (newContainer && currentContainer) {
          currentContainer.innerHTML = newContainer.innerHTML;
        } else {
          throw new Error('missing container');
        }

        var newFacets = doc.querySelector('[data-ss-facets]');
        var currentFacets = document.querySelector('[data-ss-facets]');
        if (newFacets && currentFacets) {
          currentFacets.innerHTML = newFacets.innerHTML;
        }

        var displayUrl = new URL(targetUrl.toString(), window.location.origin);
        displayUrl.searchParams.delete('section_id');
        var displayQs = displayUrl.searchParams.toString();
        var newHistoryUrl = displayUrl.pathname + (displayQs ? '?' + displayQs : '');

        if (!opts.fromPopstate) {
          history.pushState({ searchParams: displayQs }, '', newHistoryUrl);
        }

        if (container) container.classList.remove('is-loading');
        bindAll();

        if (!opts.skipScroll && container) {
          var scrollTarget =
            container.querySelector('.ss-pcard, .ss-coll__grid .grid__item, #product-grid .grid__item') ||
            container.querySelector('.ss-coll__grid, #product-grid') ||
            container;
          var top = scrollTarget.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
      })
      .catch(function () {
        if (container) container.classList.remove('is-loading');
        window.location.href = targetUrl.toString();
      });
  }

  function fetchAndRender(form, opts) {
    if (!form) return;
    fetchAndRenderUrl(urlFromForm(form, opts || {}), opts || {});
  }

  /** Use Shopify's pager href as-is — it already has page + filters */
  function fetchPageFromLink(link) {
    var href = link.getAttribute('href');
    if (!href) return;
    var targetUrl = new URL(href, window.location.origin);
    fetchAndRenderUrl(targetUrl, { skipScroll: false });
  }

  function bindPager() {
    if (document.body.dataset.ssPagerBound) return;
    document.body.dataset.ssPagerBound = '1';

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a.ss-coll__pager-btn[href]');
      if (!link || link.classList.contains('is-gap')) return;
      if (!document.getElementById('ProductGridContainer')) return;

      e.preventDefault();
      fetchPageFromLink(link);
    });
  }

  function bindForm(root) {
    var form = root.querySelector('form');
    if (!form || form.dataset.ssFacetsBound) return;
    form.dataset.ssFacetsBound = '1';

    var submit = debounce(function (e) {
      if (e) e.preventDefault();
      fetchAndRender(form, { resetPage: true });
    }, 120);

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'sort_by') {
        fetchAndRender(form, { resetPage: true });
        return;
      }
      submit(e);
    });
    form.addEventListener('input', function (e) {
      if (e.target && e.target.type === 'number') submit(e);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      fetchAndRender(form, { resetPage: true });
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-ss-facets]').forEach(function (root) {
      bindForm(root);
      if (typeof window.ssFacetsRebind === 'function') {
        window.ssFacetsRebind(root);
      }
    });
  }

  window.ssFacetsFetch = function (form) {
    fetchAndRender(form, { resetPage: false, skipScroll: true });
  };

  window.addEventListener('popstate', function () {
    var targetUrl = new URL(window.location.pathname + window.location.search, window.location.origin);
    fetchAndRenderUrl(targetUrl, { fromPopstate: true, skipScroll: true });
  });

  bindPager();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
